import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const SectionTitle = ( {
    slogan, title, classes, headingTag: HeadingTag = 'h2' 
} ) => {
    return (
        <div className={`section-title ${ classes ? classes: '' }`}>
            {slogan && <ScrollAnimation
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}
            >
                <span className="pre-title" dangerouslySetInnerHTML={{ __html: slogan }}></span>
            </ScrollAnimation>}
            
            <ScrollAnimation 
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}
            >
                <HeadingTag className="title" dangerouslySetInnerHTML={{ __html: title }}></HeadingTag>
            </ScrollAnimation>
        </div>
    )
}

export default SectionTitle;